import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import InfoDetail from './InfoDetail';
import { WhatsAppSection } from "../../Employee/Components/WhatsAppSection";
import { useSelector } from "react-redux";
import { useState } from "react";
import { KeyboardArrowDown, KeyboardArrowUp } from "../../../../components/icons";

const OwnerDetails = ({ owner, ownerKey, firmId, onWhatsappVerified, isSingle }) => {
  const dob = owner?.dob ? new Date(owner.dob).toLocaleDateString() : "-";
  
  return (
    <>
      {isSingle && (
        <InfoDetail
          label="Owner Name"
          value={owner?.name}
          direction="column"
          gap={0.5}
          labelVariant="labelD"
          valueVariant="body1"
          alignItems="flex-start"
        />
      )}
      <InfoDetail
        label="Date of Birth"
        value={dob}
        direction="column"
        gap={0.5}
        labelVariant="labelD"
        valueVariant="body1"
        alignItems="flex-start"
      />
      <InfoDetail
        label="Mobile number"
        value={owner?.mobile}
        direction="column"
        gap={0.5}
        labelVariant="labelD"
        valueVariant="body1"
        alignItems="flex-start"
      />
      <WhatsAppSection
        is_whatsapp_same={owner.is_whatsapp_same}
        OwnerWhatsappNumber={owner.whatsapp_mobile}
        ownerKey={ownerKey}
        labelDirection="row"
        firmId={firmId}
        onWhatsappVerified={onWhatsappVerified}
      />
    </>
  );
};
const FirmOwnerSection = ({
  firmId,
  owners = [],
  onAddOwner,
  onWhatsappVerified,
  ownerList,
}) => {
  const isSingle = owners.length <= 1;
  const showHistory = useSelector(state => state.entityReducer.show_history);
  
  return (
    <Box
      sx={{
        flex: { xs: '1 1 100%', md: '1 1 calc(40% - 8px)' },
        borderRadius: 2,
        p: 2,
        backgroundColor: '#FFF',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
        <Typography variant='labelD'>Firm Owner</Typography>
        {ownerList?.length > 0  && (
          <CustomButton
            variant='contained'
            color='primary'
            label='Add Owner'
            size='small'
            disabled={showHistory}
            onClick={onAddOwner}
          />
       )}
        
      </Box>
        {isSingle
          ? owners.map((owner, index) => {
              const ownerKey = owner.user_id ;
              return (

                <Box key={ownerKey} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <OwnerDetails
                    isSingle={isSingle}
                    owner={owner}
                    ownerKey={ownerKey}
                    firmId={firmId}
                    onWhatsappVerified={onWhatsappVerified}
                  />
                </Box>
              );
            })
          : owners.map((owner, index) => {
              const ownerKey = owner.user_id;
              const ownerName = owner?.name || `${owner?.firstname || ''} ${owner?.lastname || ''}`.trim() || `Owner ${index + 1}`;
              const isLast = index === owners.length - 1;
              return (
                <Box sx={{}}>
                  <Box
                    key={ownerKey}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      borderBottom: isLast ? 'none' : '1px solid #eee',
                      
                    }}
                  >
                    <Accordion
                      disableGutters
                      elevation={0}
                      sx={{
                        '&:before': { display: 'none' },
                        '& .MuiAccordionSummary-content': {
                          margin: 0,
                        },
                        gap: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        
                      }}
                    >
                      <AccordionSummary expandIcon={<KeyboardArrowDown width={24} height={24} />} sx={{ m: '0 !important', p: 0,  }}>
                        <InfoDetail
                          label="Owner Name"
                          value={ownerName}
                          direction="column"
                          gap={0.5}
                          labelVariant="labelD"
                          valueVariant="body1"
                          alignItems="flex-start"
                        />
                      </AccordionSummary>
                      <AccordionDetails sx={{
                        display: 'flex', flexDirection: 'column', gap: 1, p: 0,
                        pb: isLast ? 0 : 2 ,
                      }}>
                        <OwnerDetails
                          isSingle={isSingle}
                          owner={owner}
                          ownerKey={ownerKey}
                          firmId={firmId}
                          onWhatsappVerified={onWhatsappVerified}
                        />
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </Box>
              );
            })}
      {/* </Box> */}
    </Box>
  );
};

export default FirmOwnerSection;
